module.exports = __webpack_public_path__ + "img/ott.e750a4fe.png";